export const LONG_PULLING_INTERVAL_TIME = 7500;
export const EXIT_CONFIRMATION_PULLING_INTERVAL_TIME = 10000;

export const CONSTANTS = {
  supportEmail: 'support@parqco.com',
};
